export default "__VITE_ASSET__17de8a62__"